import { useReducer } from 'react';
import endpoints from '../../constants/configs/endpoints';
import { api, replaceParamsInStr } from '../../modules/common-utils-services/axiosUtil';
import Config from '../../constants/configs/customEndpoints'
import { CHART_CONST_INFO } from '../../constants/common/chart/chartConst';


const { WORKGROUP_BY_STATUS, 
    WORKGROUP_BY_DUEDATE, 
    WORKGROUP_BY_USER,
    WORKGROUP_DUEDATE_REPORT_BY_USER,
} = Config;

enum actions {
    DUEDATE_BY_WORKERGROUP = 'DUEDATE_BY_WORKERGROUP',
    DUEDATE_BY_USER = 'DUEDATE_BY_USER',
    DATA_ERROR = 'DATA_ERROR',
    SPINNER = 'SPINNER',
    RESOLVED_DATE_REPORTS_BY_WORKGROUP='RESOLVED_DATE_REPORTS_BY_WORKGROUP',
    RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN='RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN',
    RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE='RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE',
    RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN='RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN'
}

type Action =
    | { type: 'DUEDATE_BY_WORKERGROUP'; payload: any }
    | { type: 'DUEDATE_BY_USER'; payload: any }
    | { type: 'DATA_ERROR'; payload: undefined }
    | { type: 'DATA_ERROR'; payload: undefined }
    | { type: 'SPINNER'; payload: boolean }
    | { type: 'RESOLVED_DATE_REPORTS_BY_WORKGROUP'; payload:any }
    | { type: 'RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN'; payload:any }
    | { type: 'RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE'; payload: any }
    | { type: 'RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN'; payload: any }


function reducer(state: any, action: Action) {
    switch (action.type) {
        case actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE:
        case actions.DUEDATE_BY_WORKERGROUP:
        case actions.DUEDATE_BY_USER:
        case actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN:
        case actions.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN:
        case actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP: {
            const response = action.payload
            return {
                ...state,
                dueDateByUserData: response
            }
        }
        case actions.DATA_ERROR:
            return { ...state, isError: true }
        case actions.DATA_ERROR:
            return { ...state, isError: true }
        case actions.SPINNER:
            return { ...state, isSpinning: action.payload }
        default:
            return state;
    }
};

const initialState = {
    dueDateByWorkGroupData: {},
    dueDateByUserData: {},
     
    isSpinning: false
};

export default () => {

    const [data, dispatch] = useReducer(reducer, initialState);

    const startSpinner =() => {
        dispatch({ type: actions.SPINNER, payload: true });
    }
    const stopSpinner =() => {
        dispatch({ type: actions.SPINNER, payload: false});
    }

    const getResolvedDateReportsGroupByAssignee = async () => {
        try {
            const postRequestBody = {"assignee":""};
            const url = endpoints.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE;
            const isProd = global.__ENV__.PRODUCTION;
            let res: any= null;
            if(!isProd) {
                res = await api.get(url)
            } else {
                res = await api.post(url, postRequestBody)
            }
          
            if (res?.data) {
                dispatch({ type: actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE, payload: { ...res.data } });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: getResolvedDateReportsGroupByAssignee(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e
            );
        }
    }

    const fetchResolvedDateReportsByWorkGroup = async () => {
        try {
            const postRequestBody = {"workGroupId":""};
            const url = endpoints.RESOLVED_DATE_REPORTS_BY_WORKGROUP
            let res: any= null;
            const isProd = global.__ENV__.PRODUCTION;
            if(!isProd) {
                res = await api.get(url)
            } else {
                res = await api.post(url, postRequestBody)
            }
            if (res?.data) {
                dispatch({ type: actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP, payload: { ...res.data } });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: fetchResolvedDateReportsByWorkGroup(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e
            );
        }
    }

    const fetchResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown = async (requestBody) => {
        try {
            const postRequestBody = requestBody;
            const url = endpoints.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN
            let res: any= null;
            const isProd = global.__ENV__.PRODUCTION;
            if(!isProd) {
                res = await api.get(url)
            } else {
                res = await api.post(url, postRequestBody)
            }
            if (res?.data) {
                dispatch({ type: actions.RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN, payload: { ...res.data } });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: fetchResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e
            );
        }
    }

    const getResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown = async (requestBody) => {
        try {
            const postRequestBody = requestBody;
            const url = endpoints. url = endpoints.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN
            let res: any= null;
            const isProd = global.__ENV__.PRODUCTION;
            if(!isProd) {
                res = await api.get(url)
            } else {
                res = await api.post(url, postRequestBody)
            }
            if (res?.data) {
                dispatch({ type: actions.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN, payload: { ...res.data } });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: getResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e
            );
        }
    }
    
    const fetchDueDateByWorkGroup = async (requestBody) => {

        const { activeChart, dueDate, workgroup } = requestBody

        const isDueDateChart = activeChart === CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE;
        const isDueDateChartByUser = activeChart === CHART_CONST_INFO.ACTIVATE_DUEDATE_BY_USERS;
        const isStatusChart = activeChart === CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_STATUS;
        const isStatusChartByUser = activeChart === CHART_CONST_INFO.ACTIVATE_STATUS_BY_USERS;


        try {
            let url = "";
            const isProd = global.__ENV__.PRODUCTION;
            let res: any = null;
            if (!isProd) {
                url = isDueDateChart ? WORKGROUP_BY_DUEDATE
                    : isStatusChart ? WORKGROUP_BY_STATUS
                        : isDueDateChartByUser ? WORKGROUP_DUEDATE_REPORT_BY_USER
                            : isStatusChartByUser ? WORKGROUP_BY_USER : '';
                const endpoint = replaceParamsInStr(url, { dueDate: dueDate, workgroup: workgroup });
                res = await api.get<any>(endpoint);
            } else {
                url = (isDueDateChart || isDueDateChartByUser) ? endpoints.WORKGROUP_BY_DUEDATE
                    : isStatusChart ? endpoints.WORKGROUP_BY_STATUS
                        : endpoints.WORKGROUP_BY_USER;
                const postRequestBody = {
                    "dueDate": dueDate,
                }
                if (isDueDateChartByUser || isStatusChartByUser) { postRequestBody["workgroupId"] = workgroup }
                const endpoint = replaceParamsInStr(url, { dueDate: dueDate, workgroup: workgroup });
                if (isDueDateChart || isDueDateChartByUser || isStatusChart || isStatusChartByUser) {
                    res = await api.post(url, postRequestBody)
                } else {
                    res = await api.get<any>(endpoint);
                }
            }

            if (res?.data) {
                dispatch({ type: actions.DUEDATE_BY_WORKERGROUP, payload: { ...res.data } });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: fetchDueDateByWorkGroup(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e
            );
        }
    };


    return {
        chartInfoData:data,
        fetchDueDateByWorkGroup: (selectedChart: any) => {
            return fetchDueDateByWorkGroup(selectedChart);
        },
        fetchResolvedDateReportsByWorkGroup: () =>{
            return fetchResolvedDateReportsByWorkGroup();
        },
        fetchResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown: (requestBody)=>{
            return fetchResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown(requestBody);
        },
        getResolvedDateReportsGroupByAssignee: ()=>{
            return getResolvedDateReportsGroupByAssignee();
        },
        getResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown:(requestBody)=>{
            return getResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown(requestBody)
        },
        startSpinner:() =>{
            return startSpinner()
        },
        stopSpinner:() =>{
            return stopSpinner()
        }
    };
};